import { CompanySuggestion } from '@savgroup-front-common/types/CompanyDirectory';

const COMPANY_DETAILS_SEPARATOR = ' — ';

export const formatCompanyDetails = (company: CompanySuggestion): string =>
  [company.registrationNumber, company.facts?.activitySector]
    .filter((detail) => !!detail)
    .join(COMPANY_DETAILS_SEPARATOR);

export const formatCNameInput = (value: string): string =>
  value.trim().toLowerCase();
